import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { NewOwnershipConversionRequestComponent } from './new-ownership-conversion-request/new-ownership-conversion-request.component';
import { OwnershipConversionPortalRoutingModule } from './ownership-conversion-portal-routing.model';
import { OwnershipConversionPortalComponent } from './ownership-conversion-portal.component';

@NgModule({
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    OwnershipConversionPortalRoutingModule,
  ],
  declarations: [
    OwnershipConversionPortalComponent,
    NewOwnershipConversionRequestComponent,
  ],
})
export class OwnershipConversionPortalModule {}
